import { Controller } from "@hotwired/stimulus"

// Multi-select chips → injecte des hidden inputs name="<name>[]"
// puis soumet le form parent. Utilisé Story 1.6-fix sur Formation B2C.
export default class extends Controller {
  static targets = ["chip", "hidden"]
  static values = { name: String }

  toggle(event) {
    event.preventDefault()
    const chip = event.currentTarget
    chip.classList.toggle("is-active")
    this._syncHiddens()
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  _syncHiddens() {
    this.hiddenTargets.forEach(h => h.remove())
    this.chipTargets.forEach(chip => {
      if (!chip.classList.contains("is-active")) return
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = `${this.nameValue}[]`
      input.value = chip.dataset.value || ""
      input.setAttribute("data-category-chips-target", "hidden")
      this.element.appendChild(input)
    })
  }
}
